import { http } from './http';
import type { ApiSuccess, StreamDescriptor } from './types';

export const streamsApi = {
  async getDescriptor(cameraId: number, signal?: AbortSignal): Promise<StreamDescriptor> {
    const res = await http.get<ApiSuccess<StreamDescriptor>>(
      `/api/cameras/${cameraId}/stream`,
      { signal },
    );
    return res.data.data;
  },
};
